
const Benefits = ({ data }) => {
    return (
        <section className="overflow-hidden">
            <div className="container">
                {data.map((item, index) => (
                    <div className="row gridflex"
                    >
                        <div className={`col-lg-6 ${index % 2 === 0 ? 'order-lg-1' : 'order-lg-2'}`}
                            data-aos={`fade-${index % 2 === 1 ? "left" : "right"}`} data-aos-delay="300"

                        >
                            <div className="d-flex gridgap mb-2">
                                <div className="circleservice" style={{ flex: "none" }}>{index + 1}</div>
                                <h1 className="servicebenefit">{item.heading}</h1>
                            </div>
                            <div className="servicefontb" dangerouslySetInnerHTML={{ __html: item.para1 }}></div>
                        </div>
                        <div
                            data-aos={`fade-${index % 2 === 1 ? "right" : "left"}`} data-aos-delay="300"
                            className={`col-lg-6 gridimage ${index % 2 === 0 ? 'order-lg-2' : 'order-lg-1'}`}>
                            <img className="bulkwidth" src={item.img} alt={`Visual for ${item.heading}`} />
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default Benefits
